module.exports = __webpack_public_path__ + "img/rikel.792233e9.jpg";